<footer class="main-footer">
    <strong>Copyright &copy; 2020 <a href="#"></a></strong>
    All rights reserved.
    <div class="float-right d-none d-sm-inline-block">
      <a href="#">Privacy Policy</a>
    </div>
  </footer>